module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 08 Farma Pasa - Ouneki.0c2945b1.mp3";